export enum APIVerbs {
  GET = 'GET',
  POST = 'POST',
  DOWNLOAD = 'DOWNLOAD'
}

export enum MediaTypes {
  file = 'file',
  image = 'image',
  gif = 'gif',
  video = 'video',
  audio = 'audio',
  thumbnail = 'thumbnail',
  icon = 'icon',
  iconThumbnail = 'iconThumbnail',
  media = 'media',
  mediaThumbnail = 'mediaThumbnail',
  menuMedia = 'menuMedia'
}

export enum MimeTypes {
  png = 'image/png',
  jpg = 'image/jpg',
  jpeg = 'image/jpeg',
  gif = 'image/gif',
  svg = 'image/svg+xml',
  webp = 'image/webp',
  mp4 = 'video/mp4',
  webm = 'video/webm',
  ogg = 'video/ogg',
  mp3 = 'audio/mpeg',
  wav = 'audio/wav',
  pdf = 'application/pdf',
  doc = 'application/msword',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls = 'application/vnd.ms-excel',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt = 'application/vnd.ms-powerpoint',
  pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt = 'text/plain',
  json = 'application/json',
  xml = 'application/xml',
  zip = 'application/zip',
  rar = 'application/x-rar-compressed',
  sevenz = 'application/x-7z-compressed',
  csv = 'text/csv',
  html = 'text/html',
  css = 'text/css',
  js = 'application/javascript',
  ts = 'application/typescript',
  jsx = 'text/jsx',
  tsx = 'text/tsx'
}


export enum Strings {
  cloudinaryMediaUpload = '/upload/',
  cloudinaryMediaQuality = '/upload/h_240,f_auto,q_auto/'
}
